import React from 'react';
import { Form } from 'react-bootstrap';

export default function AppointmentTab({
    editingNote,
    noteForm,
    onInputChange,
    handleDateChange,
    hasContentThatPreventsDateChange,
}) {
    return (
        <>
            <Form.Group className="mb-3">
                <Form.Label>Date</Form.Label>
                <Form.Control
                    type="date"
                    name="date"
                    value={noteForm.date}
                    onChange={handleDateChange}
                    required
                />
                {editingNote && hasContentThatPreventsDateChange() && (
                    <Form.Text className="text-warning">
                        <i className="fas fa-exclamation-triangle me-1"></i>
                        This note contains medical data. Future dates are not allowed.
                    </Form.Text>
                )}
            </Form.Group>

            {(!editingNote || noteForm.type === 'appointment') && (
                <Form.Group className="mb-3">
                    <Form.Label>Appointment Note</Form.Label>
                    <Form.Control
                        type="text"
                        name="appointment_note"
                        value={noteForm.appointment_note || ''}
                        onChange={onInputChange}
                        placeholder="Brief appointment summary (one sentence)"
                        maxLength={255}
                    />
                    <Form.Text className="text-muted">
                        Keep it brief - this is a quick summary of the appointment.
                    </Form.Text>
                </Form.Group>
            )}
        </>
    );
}
